export class TimeoutError extends Error {
  constructor(message = 'Operation timed out') {
    super(message);
    this.name = 'TimeoutError';
  }
}

/**
 * Rejects if `promise` does not settle within `ms`.
 * The underlying work is not aborted (Firestore SDK has no cancel).
 */
export function withTimeout<T>(promise: Promise<T>, ms: number, message?: string): Promise<T> {
  if (!Number.isFinite(ms) || ms <= 0) {
    return promise;
  }

  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      reject(new TimeoutError(message ?? `Timed out after ${ms}ms`));
    }, ms);
  });

  return Promise.race([promise, timeout]).finally(() => {
    if (timer !== undefined) clearTimeout(timer);
  });
}
